import type { FC } from 'react'
import { Sidebar } from './Sidebar'
import {
  SidebarMenuSection,
  SidebarNavigationSection,
  SidebarStatusSection,
} from '@/features/sidebar'
import { SidebarUserSection } from '../user'

export const DashboardSidebar: FC = () => {
  return (
    <Sidebar
      StatusSection={SidebarStatusSection}
      NavigationSection={SidebarNavigationSection}
      MenuSection={SidebarMenuSection}
      UserSection={SidebarUserSection}
    />
  )
}
